import { ObjectSuperTypesEnum } from "../enums";

const validTypes = [
  ObjectSuperTypesEnum.Row,
  ObjectSuperTypesEnum.RectTable,
  ObjectSuperTypesEnum.RoundTable,
];

export const getSeats = (canvas: any) => {
  return (
    canvas
      .getObjects()
      .filter((item:any) => validTypes.includes(item.superType))
      ?.flatMap((row:any) => row._objects)
      ?.filter((object:any) => object.superType == ObjectSuperTypesEnum.Seat) ?? []
  );
};

// setNumber = (seats) => (numberSeats = seats.length);

export const getDuplicates = (seats: any) => {
  const findDuplicates = seats.reduce((acc: any, seat: any) => {
    acc[seat.value] = ++acc[seat.value] || 0;
    return acc;
  }, {});

  return seats.filter((seat: any) => {
    return findDuplicates[seat.value];
  });
};

export const getNotCategorized = (seats: any) => {
  return seats.filter((seat: any) => !seat.category.name);
};

export const getUnlabeled = (seats: any) => {
  return seats.filter((seat: any) => !seat.isLabeled);
};